import { Col, Row } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import Img from 'gatsby-image';
import SEO from '../components/seo';
import TrailTitle from '../components/TrailTitle';
import { graphql } from 'gatsby';

const SchedulePage = ({ data, location }) => {
  const [open, setOpen] = useState(false);


  useEffect(() => {
    setOpen((o) => !o);

    return () => {
      setOpen((o) => !o);
    };
  }, []);


  return (
    <>
      <SEO
        title='Jadwal Dokter'
        pathname='/schedule'
        description='Jadwal jaga dokter gigi umum dan jadwal dokter gigi spesialis RSGM IIK Bhakti Wiyata Kediri.'
      />
      <Img fluid={data.cover.childImageSharp.fluid} />
      <Row
        css={{
          minHeight: '75vh',
          backgroundImage: `url(${data.bg.childImageSharp.fixed.src})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top right',
        }}
        className='pt-5'>
        <Col
          sm={'5'}
          className='d-flex flex-column align-items-center align-content-center'
          css={{ justifyContent: 'space-between' }}>
          <TrailTitle open={open} className='pb-2 mb-5'>
            <div>Jadwal Kerja</div>
            <div>RSGM IIK Bhakti Wiyata</div>
          </TrailTitle>
        </Col>

        <Col xs={'12'} sm={{ span: '8', offset: 2 }} className='py-3'>
          <div className='mb-4'>
            <h3 className="font-weight-bold">Jadwal Jaga Dokter Gigi Umum</h3>
            <p className="">RSGM IIK Bhakti Wiyata</p>
            {data.jadwalUmum && <Img className={'img-fluid'} alt='Jadwal Jaga Dokter Gigi Umum' fluid={data.jadwalUmum.childImageSharp.fluid} />}
          </div>
          <div className='mt-5 mb-4'>
            <h3 className="font-weight-bold">Jadwal Dokter Gigi Spesialis</h3>
            <p className="">RSGM IIK Bhakti Wiyata</p>
            {data.jadwalSpesialis && <Img className={'img-fluid'} alt='Jadwal Dokter Gigi Spesialis' fluid={data.jadwalSpesialis.childImageSharp.fluid} />}
          </div>
        </Col>
      </Row>

    </>
  )

}

export const query = graphql`
  {
    bg: file(name: { eq: "bg-ring" }) {
      childImageSharp {
        fixed(toFormat: WEBP) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    cover: file(name: { eq: "bg-common" }) {
      childImageSharp {
        fluid(maxWidth: 1920, toFormat: WEBP) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    jadwalUmum: file(name: { eq: "jadwal-umum" }) {
      childImageSharp {
        fluid(maxWidth: 1920, toFormat: WEBP) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    jadwalSpesialis: file(name: { eq: "jadwal-spesialis" }) {
      childImageSharp {
        fluid(maxWidth: 1920, toFormat: WEBP) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default SchedulePage